import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Soft%20minimalist%20abstract%20background%20with%20pastel%20cream%20and%20sage%20green%20tones%2C%20gentle%20flowing%20gradient%20shapes%2C%20clean%20fresh%20airy%20aesthetic%2C%20no%20text%2C%20light%20editorial%20style%2C%20high%20detail%2C%20calm%20and%20spacious%20composition&width=1600&height=900&seq=hero-bg-01&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/5 to-black/15" />

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide uppercase">
              {t("hero_eyebrow")}
            </span>
            <h1 className="mt-5 text-3xl md:text-5xl lg:text-[56px] font-heading font-bold text-foreground-950 leading-tight">
              {t("hero_title")}
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed max-w-2xl">
              {t("hero_subtitle")}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                {t("hero_cta_primary")}
                <i className="ri-arrow-right-up-line" />
              </a>
              <a
                href="#articles"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-900 font-semibold text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                {t("hero_cta_secondary")}
              </a>
            </div>

            <p className="mt-6 text-sm text-foreground-600">{t("hero_trust")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}